






























































import { Vue, Component, Prop } from "vue-property-decorator";
import dompurify from "dompurify";
@Component({
  name: "tree-menu-field"
})
export default class TreeMenuField extends Vue {
  // Props
  @Prop({ required: false })
  public category!: object;
  @Prop({ default: "" })
  public searchedValue!: string;

  public onClick(categoryId) {
    this.$emit("click", categoryId);
  }

  public get isOpen() {
    return this.$_.get(this.category, "isOpen", false);
  }

  public getCategoryName() {
    const name = this.$_.get(
      this.category,
      "name_translated",
      this.$_.get(this.category, "name")
    );
    return `${this.getHighlighted(
      dompurify.sanitize(name),
      this.searchedValue
    )}`;
  }

  public getHighlighted(oldString, searchedString) {
    const index = oldString.toLowerCase().indexOf(searchedString.toLowerCase());
    if (index === 0 && searchedString.length) {
      return `<span class="has-text-primary">${oldString.substr(
        0,
        searchedString.length
      )}</span>${
        oldString.length === searchedString.length
          ? ""
          : this.getHighlighted(
              oldString.substr(searchedString.length, oldString.length - 1),
              searchedString
            )
      }`;
    }

    if (index > 0) {
      return `${oldString.substr(
        0,
        index
      )}<span class="has-text-primary">${oldString.substr(
        index,
        searchedString.length
      )}</span>${this.getHighlighted(
        oldString.substr(index + searchedString.length, oldString.length - 1),
        searchedString
      )}`;
    }

    return oldString;
  }
}
